var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.8536 3.85355C25.0488 3.65829 25.0488 3.34171 24.8536 3.14645C24.6583 2.95118 24.3417 2.95118 24.1464 3.14645L14 13.2929L3.85355 3.14645C3.65829 2.95118 3.34171 2.95118 3.14645 3.14645C2.95118 3.34171 2.95118 3.65829 3.14645 3.85355L13.2929 14L3.14645 24.1464C2.95118 24.3417 2.95118 24.6583 3.14645 24.8536C3.34171 25.0488 3.65829 25.0488 3.85355 24.8536L14 14.7071L24.1464 24.8536C24.3417 25.0488 24.6583 25.0488 24.8536 24.8536C25.0488 24.6583 25.0488 24.3417 24.8536 24.1464L14.7071 14L24.8536 3.85355Z",
  fill: "currentColor"
})));
export default SvgClose28;